import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LinksService } from '../services/links.service';

@Pipe({
  name: 'urlify',
  standalone: false
})
export class UrlifyPipe implements PipeTransform {
  private URL_REGEX = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

  constructor(private domSanitizer: DomSanitizer) {}

  transform(text: string) {
    if (!text) {
      return;
    }

    const convertedHTML = text.replace(this.URL_REGEX, (url) => {
      const safeUrl = url.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      return `<a href="${safeUrl}" class="${LinksService.SYSTEM_LINK_CLASS}" rel="noopener noreferrer">${url}</a>`;
    });
    return this.domSanitizer.bypassSecurityTrustHtml(convertedHTML);
  }
}
